export class Brochure {
    prepa: BrochurePrepa[];
    b2b: BrochureB2b[];

    constructor(options?: any) {
        if (options) {
            this.prepa = options.prepa;
            this.b2b = options.b2b;
        }
    }
}

export class BrochurePrepa {
    lien_brochure: string;
    titre_produit: string;
    nom_instance: string;

    constructor(options?: any) {
        if (options) {
            this.lien_brochure = options.lien_brochure;
            this.titre_produit = options.titre_produit;
            this.nom_instance = options.nom_instance;
        }
    }
}

export class BrochureB2b {
    lien_brochure: string;
    titre_produit: string;
    nom_instance: string;

    constructor(options?: any) {
        if (options) {
            this.lien_brochure = options.lien_brochure;
            this.titre_produit = options.titre_produit;
            this.nom_instance = options.nom_instance;
        }
    }
}
